import Vue from 'vue';
import initService from "./init-service";
import sessionIdDirective from "../directive/sessionId-directive";
// import commonService from "./common";
import AdministratorService from "@/common/api-services/administrator-service";
// import coreutils from "@/common/coreutils";

let baseurl = "";
  if(process.env.VUE_APP_CONFIG_ESIM_BASEURL == undefined){
    baseurl = process.env.VUE_APP_CONFIG_BASEURL
  }else {
    baseurl = process.env.VUE_APP_CONFIG_ESIM_BASEURL
  };
let apikey = `${process.env.VUE_APP_CONFIG_APIKEY}`;
let userName = initService.getUserNameInfo();
let customer = initService.getCustomerInfo();
let group = initService.getGroupInfo();
let pId = sessionIdDirective.getJSessionId();
let headers = {
  headers: {
    "Content-Type": "application/json",
    "x-api-key": apikey,
  },
};
const AuthService = {

  //NOTE: This page uses the customer Administrator to allow registration for Admin functions.

  async getLogin(credential) {
    let url = `${baseurl}?method=IOT_Login&credentials=${credential}&auth=1&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async logoutService() {
    let url = `${baseurl}?method=IOT_Logout&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async register(data) {
    let url = `${baseurl}?method=IOT_Register&data=${data}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async forgetPassword(username) {
    let url = `${baseurl}?method=IOT_ForgotPassword&username=${username}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async resetPassword(credentials, code) {
    let url = `${baseurl}?method=IOT_ConfirmForgotPassword&credentials=${credentials}&code=${code}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async updatePassword(data) {
    let url = `${baseurl}?method=IOT_ChangePassword&data=${data}&auth=1&user=${userName}&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async respondNewPasswordChallenge(session, credentials) {
    let url = `${baseurl}?method=IOT_RespondNewPasswordChallenge&session=${session}&credentials=${credentials}&auth=1&&customer=${customer}&group=${group}&pid=${pId}`;
    return Vue.axios.get(url, headers);
  },

  async updateUserProfile(username, attr) {
    //NOTE:  this needs to be the user update profile.  The admin method is on the admin service.
    AdministratorService.updateUserProfile(username, attr);
  },


  //TODO: find a better way to store this
  async getActivityLog() {
    let url = `${baseurl}?method=IOT_GetSubscriberLogs&period=15_min&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
    return Promise.resolve(Vue.axios.get(url, headers))
        .then(response => response.data.message)
        .catch(error => console.error(error));

    // let param = `IOT_GetSubscriberLogs&period=15_min`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.error(error))
  },

  //TODO: find a better way to store this
  async setActivityLog(action, details, isError = 0) {
    //get the customer, and user
    let userName = initService.getUserNameInfo();
    details = encodeURIComponent(JSON.stringify(details))

    let url = `${baseurl}?method=IOT_AddLog&api=${action}&fault=${isError}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}&response=${details}`;
    return Vue.axios.get(url, headers)
       .then(response => response.data.message)
       .catch(error => console.error(error));


    //let param = `IOT_AddLog&&api=${action}&response=${details}&fault=${isError}&user=${userName}`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.error(error));
  },

  //TODO: find a better way to store this
  async getTransactionHistory(period) {
    let url = `?method=IOT_GetSubscriberLogs&period=${period}&customer=${customer}&user=${userName}&group=${group}&pid=${pId}`;
    //console.log(url);
    return Promise.resolve(Vue.axios.get(url, headers))
        .then(response => response.data.message)
        .catch(error => console.error(error));

    // let param = `IOT_GetSubscriberLogs&period=${period}`;
    // return commonService.commonAPI(param)
    //   .then(response => response.data.message)
    //   .catch(error => console.log(error))
  },

};

export default AuthService;
